import React from "react";
import { CircularProgress, Typography } from "@mui/material";

// Component for displaying test properties
const TestProperties = ({ properties, loading }) => (
    <div className="test-properties-box">
        <div className="test-properties-title">
            To test API responses, please use the following properties:
        </div>
        <div className="test-properties-list">
            {loading ? (
                <div className="test-properties-loading">
                    <CircularProgress size={24} />
                    <Typography sx={{ ml: 2, color: "#6B7280" }}>
                        Loading test properties...
                    </Typography>
                </div>
            ) : properties.length > 0 ? (
                properties.map((prop, idx) => (
                    <div className="test-properties-item" key={prop.code}>
                        <div className="test-properties-index">{idx + 1}</div>
                        <div className="test-properties-pair-group">
                            <div className="test-properties-pair">
                                <span className="test-properties-label">
                                    Name:
                                </span>
                                <span className="test-properties-value">
                                    {prop.name}
                                </span>
                            </div>
                            <div className="test-properties-pair">
                                <span className="test-properties-label">
                                    Code:
                                </span>
                                <span className="test-properties-value">
                                    {prop.code}
                                </span>
                            </div>
                        </div>
                    </div>
                ))
            ) : (
                <Typography sx={{ color: "#6B7280", textAlign: "center" }}>
                    No test properties found
                </Typography>
            )}
        </div>
    </div>
);

export default TestProperties;
